import {Toolbar, ToolbarProps} from '@material-ui/core';
import * as React from 'react';
import {compose} from 'redux';
import SaveButton, {SaveButtonPropsShape} from './SaveButton';

interface ExternalToolbarProps extends ToolbarProps {
    handleSubmitWithRedirect?: Function;
    loading?: boolean;
    toolbarClassName?: string;
    submitOnEnter?: boolean;
    SaveButtonProps?: SaveButtonPropsShape;
}

interface InternalToolbarProps extends ToolbarProps {
    handleSubmitWithRedirect: Function;
    loading?: boolean;
    toolbarClassName?: string;
    saveButtonLabel: string;
    saveButtonIcon: React.FunctionComponent<object>;
    submitOnEnter: boolean;
    SaveButtonProps?: SaveButtonPropsShape;
    handleSubmit: Function;
    handleDelete: Function;
}

const OnlySaveToolbar: React.FunctionComponent<InternalToolbarProps> = ({
    handleSubmitWithRedirect,
    loading,
    toolbarClassName,
    saveButtonLabel,
    saveButtonIcon,
    submitOnEnter,
    SaveButtonProps = {},
    handleSubmit: _handleSubmit,
    handleDelete: _handleDelete,
    ...rest
}: InternalToolbarProps) => (
    <Toolbar className={`edit-form-toolbar ${toolbarClassName}`} {...rest}>
        <SaveButton
            handleSubmitWithRedirect={handleSubmitWithRedirect}
            loading={loading}
            saveButtonIcon={saveButtonIcon}
            saveButtonLabel={saveButtonLabel}
            submitOnEnter={submitOnEnter}
            {...SaveButtonProps}
        />
    </Toolbar>
);

// @ts-ignore
const SimpleFormOnlySaveToolbar: React.ComponentType<ExternalToolbarProps> = compose()(OnlySaveToolbar);

export default SimpleFormOnlySaveToolbar;
